<template>
  <div class="container">
    <div>
      <Macau />
      <br />
      <Gbp />
    </div>
  </div>
</template>

<script>
import Macau from "./Macau.vue";
import Gbp from "./Gbp.vue";

export default {
  components: {
    Macau,
    Gbp,
  },
  // name: "App",
  // props: [],

  // data() {
  //   return {
  //     activeTitle: "新公司計算器",
  //     activeCal: "NewCompanyCal",
  //   };
  // },
};
</script>
